import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=e010330c&scoped=true&"
import script from "./Base.vue?vue&type=script&lang=js&"
export * from "./Base.vue?vue&type=script&lang=js&"
import style0 from "../../Style/create.scss?vue&type=style&index=0&id=e010330c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e010330c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e010330c')) {
      api.createRecord('e010330c', component.options)
    } else {
      api.reload('e010330c', component.options)
    }
    module.hot.accept("./Base.vue?vue&type=template&id=e010330c&scoped=true&", function () {
      api.rerender('e010330c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/IoFormat/Components/Formats/Base.vue"
export default component.exports